import {AfterContentInit, Component, inject, Input, NO_ERRORS_SCHEMA, TemplateRef, ViewChild} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import { BoxModelComponent } from '../components/box-model/box-model.component';
import { CheckboxsetComponent } from '../components/checkboxset/checkboxset.component';
import { DeviceConfigComponent } from '../components/device-config/device-config.component';
import { WMSColorpickerComponent } from '../components/colorpicker/colorpicker.component';
import { WMSOrderbyComponent } from '../components/orderby/orderby.component';
import { WMSClasspickerComponent } from '../components/classpicker/classpicker.component';
import { EventHandlerComponent } from '../components/event-handler/event-handler.component';
import { RoleSelectorComponent } from '../components/role-selector/role-selector.component';
import { WmTabOrderComponent } from '../components/wm-tab-order/wm-tab-order.component';
import {
   PropertiesPanelComponent
} from "@wms/properties-panel";
import {BaseComponent, WmsToggleComponent, WmsTypeaheadComponent} from "@wms/components";
import {CommonWidgetDirective} from "@wms/directives";
import {TemplateService} from "@wms/app/properties-panel/properties-template/template-service";
import {get, set} from "lodash-es";
import {BsDropdownModule} from "ngx-bootstrap/dropdown";
import { IconSelectorGridComponent } from '../components/icon-selector-grid/icon-selector-grid.component';
import { InputSelectComponent } from '../components/input-select/input-select.component';
import { SpacingControlComponent } from '../components/spacing-control/spacing-control.component';

const supportedTypes = ['date','time','textarea','multi-select','select-all',
  'access-roles-select','eventlist','events-typehead-item','list-typeahead','list-number','select-by-object'
  ,'list-group','color','button','toolbar','radio','taggle-radio','icons-checkbox','checkbox','checkboxset',
  'box-model-template','device-config-template','device-config-template-mobile','device-config-template-tab',
  'pages-list','templates-list','pagedialog-pages-list',"fileupload-relativepath",
  "order-by","date-patterns","date-time-patterns","time-patterns", "data-list", "icon-selector-grid",
  "tab-order","update-on", "add-widget-by-prop","add-widget","tree-datavalue",
  "label","list-picker", "device-config", 'toggle','slider','string', 'list','boolean',
  'number','select-icon','box','box-model','border-style','toggle-checkbox',
  'icons-align','icons-radio', 'conditional-expression', 'pages-list', 'toggle-radio', 'add-widget-property','spacing-list', 'input-select', 'variant-typeahead', 'spacing-control'];

@Component({
  selector: 'wms-property-templates-list',
  templateUrl: './property-templates-list.component.html',
  styleUrls: ['./property-templates-list.component.less'],
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    CommonWidgetDirective,
    WmsToggleComponent,
    BoxModelComponent,
    CheckboxsetComponent,
    DeviceConfigComponent,
    WMSColorpickerComponent,
    WMSOrderbyComponent,
    IconSelectorGridComponent,
    InputSelectComponent,
    SpacingControlComponent,
    WMSClasspickerComponent,
    EventHandlerComponent,
    RoleSelectorComponent,
    WmsTypeaheadComponent,
    WmTabOrderComponent,
    BsDropdownModule
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class PropertyTemplatesListComponent extends BaseComponent implements AfterContentInit {

  @ViewChild('string', {static: true}) stringTemplate: TemplateRef<any> | undefined;
  @ViewChild('list', {static: true}) listTemplate: TemplateRef<any> | undefined;
  @ViewChild('boolean', {static: true}) booleanTemplate: TemplateRef<any> | undefined;
  @ViewChild('number', {static: true}) numberTemplate: TemplateRef<any> | undefined;
  @ViewChild('selecticon', {static: true}) selecticonTemplate: TemplateRef<any> | undefined;
  @ViewChild('boxmodel', {static: true}) boxmodelTemplate: TemplateRef<any> | undefined;
  @ViewChild('borderstyle',{static: true}) borderstyleTemplate: TemplateRef<any> | undefined;
  @ViewChild('togglecheckbox', {static: true}) togglecheckboxTemplate: TemplateRef<any> | undefined;
  @ViewChild('iconsalign', {static: true}) iconsalignTemplate: TemplateRef<any> | undefined;
  @ViewChild('iconsradio', {static: true}) iconsradioTemplate: TemplateRef<any> | undefined;
  @ViewChild('button', {static: true}) buttonTemplate: TemplateRef<any> | undefined;
  @ViewChild('toolbar', {static: true}) toolbarTemplate: TemplateRef<any> | undefined;
  @ViewChild('slider', {static: true}) sliderTemplate: TemplateRef<any> | undefined;
  @ViewChild('selectall', {static: true}) selectallTemplate: TemplateRef<any> | undefined;
  @ViewChild('date', {static: true}) dateTemplate: TemplateRef<any> | undefined;
  @ViewChild('time', {static: true}) timeTemplate: TemplateRef<any> | undefined;
  @ViewChild('datepatterns', {static: true}) datepatternsTemplate: TemplateRef<any> | undefined;
  @ViewChild('timepatterns', {static: true}) timepatternsTemplate: TemplateRef<any> | undefined;
  @ViewChild('datetimepatterns', {static: true}) datetimepatternsTemplate: TemplateRef<any> | undefined;
  @ViewChild('textarea', {static: true}) textareaTemplate: TemplateRef<any> | undefined;
  @ViewChild('listpicker', { static : true }) listpickerTemplate : TemplateRef<any> | undefined;
  @ViewChild('deviceconfig', {static: true}) deviceconfigTemplate: TemplateRef<any> | undefined;
  @ViewChild('color', { static : true }) colorTemplate : TemplateRef<any> | undefined;
  @ViewChild('datalist',{static:true}) datalistTemplate : TemplateRef<any> | undefined;
  @ViewChild('updateon',{static:true}) updateonTemplate : TemplateRef<any> | undefined;
  @ViewChild('orderby',{static:true}) orderbyTemplate : TemplateRef<any> | undefined;
  @ViewChild('listtypeahead',{static:true}) listtypeaheadTemplate : TemplateRef<any> | undefined;
  @ViewChild('varianttypeahead',{static:true}) varianttypeaheadTemplate : TemplateRef<any> | undefined;
  @ViewChild('addwidgetproperty',{static:true}) addwidgetpropertyTemplate : TemplateRef<any> | undefined;
  @ViewChild('eventlist',{static:true}) eventlistTemplate: TemplateRef<any> | undefined;
  @ViewChild('fileuploadrelativepath',{static:true}) fileuploadrelativepathTemplate: TemplateRef<any> | undefined;
  @ViewChild('selectbyobject',{static:true}) selectbyobjectTemplate: TemplateRef<any> | undefined;
  @ViewChild('listnumber',{static:true}) listnumberTemplate: TemplateRef<any> | undefined;
  @ViewChild('addwidget',{static:true}) addwidgetTemplate: TemplateRef<any> | undefined;
  @ViewChild('treedatavalue',{static:true}) treedatavalueTemplate: TemplateRef<any> | undefined;
  @ViewChild('pageslist',{static:true}) pageslistTemplate: TemplateRef<any> | undefined;
  @ViewChild('taborder',{static:true}) taborderTemplate: TemplateRef<any> | undefined;
  @ViewChild('multiselect',{static:true}) multiselectTemplate: TemplateRef<any> | undefined;
  @ViewChild('conditionalexpression', {static: true}) conditionalexpressionTemplate: TemplateRef<any> | undefined;
  @ViewChild('toggleradio', {static: true}) toggleradioTemplate: TemplateRef<any> | undefined;
  @ViewChild('toggle', {static: true}) toggleTemplate: TemplateRef<any> | undefined;
  @ViewChild('accessrolesselect', {static: true}) accessrolesselectTemplate: TemplateRef<any> | undefined;
  @ViewChild('listgroup', {static: true}) listgroupTemplate: TemplateRef<any> | undefined;
  @ViewChild('box', {static: true}) boxTemplate: TemplateRef<any> | undefined;
  @ViewChild('checkbox', {static: true}) checkboxTemplate: TemplateRef<any> | undefined;
  @ViewChild('checkboxset', {static: true}) checkboxsetTemplate: TemplateRef<any> | undefined;
  @ViewChild('label', {static: true}) labelTemplate: TemplateRef<any> | undefined;
  @ViewChild('select-all', {static: true}) orderByTemplate: TemplateRef<any> | undefined;
  @ViewChild('radio', {static: true}) radioTemplate: TemplateRef<any> | undefined;
  @ViewChild('iconselectorgrid',{static:true}) iconselectorgridTemplate : TemplateRef<any> | undefined;
  @ViewChild('spacinglist',{static:true}) spacinglistTemplate : TemplateRef<any> | undefined;
  @ViewChild('inputselect',{static:true}) inputselectTemplate : TemplateRef<any> | undefined;
  @ViewChild('spacingcontrol',{static:true}) spacingcontrolTemplate : TemplateRef<any> | undefined;

  scrollBehaviourAppConfigValue = '';

  private templateService: TemplateService;

  constructor() {
    super();
    this.templateService = inject(TemplateService);
    if (this.projectService.isNativeMobileApplicationType()) {
      this.projectService.getRNBuildConfig().then((response: string) => {
        let parsedResponseObj = JSON.parse(response);
        this.scrollBehaviourAppConfigValue = parsedResponseObj?.edgeToEdgeConfig?.scrollBehaviour;
      });
    }    
  }

  ngAfterContentInit(): void {
    supportedTypes.forEach((type: string) => {
      const temp = type.split('-');
      let templateRef = get(this, temp.join('') + 'Template');
      set(this.templateService, type, templateRef);
    });
    }
}
